import React from 'react';
import {
  FlexRow,
  IconButton,
  Text,
  FlexSpacer,
  Dropdown,
  DropdownMenuButton,
  Panel,
} from '@epam/promo';
import { ReactComponent as navigationMoreIcon } from '@epam/assets/icons/common/navigation-more_horiz-18.svg';
import { ReactComponent as DeleteIcon } from '@epam/assets/icons/common/action-delete-12.svg';
import dayjs from 'dayjs';
import { useUserStore } from 'store/user.store';
import { StatusIndicator } from 'components/common';
import { TASK_STATUS } from 'models/task.model';
import { useDropdown } from 'hooks';
import { CardProps } from './Card.model';
import css from './Card.module.scss';

export const Card = ({ item, isActive, onClick, onDelete }: CardProps) => {
  const { openDropdownMenu } = useDropdown();
  const user = useUserStore((state) => state.user);

  return (
    <div
      aria-hidden="true"
      className={isActive ? css['card__active-container'] : css.card__inactive}
      role="button"
      tabIndex={0}
      onClick={onClick}>
      <li className={isActive ? `${css.card} ${css.card__active}` : css.card}>
        <FlexRow padding="12" size="24">
          <Text cx={css.card__title} font="sans-semibold" size="48">
            <div className={css['card__title-text']}>
              {item.title || 'Title'}
            </div>
          </Text>
          <FlexSpacer />
          {(user.role === 'SUPER_ADMIN' ||
            (user.role === 'ADMIN' && item.status === 'DRAFT') ||
            item.status === 'NOT_SAVED') && (
            <Dropdown
              placement="bottom-end"
              renderBody={() => (
                <Panel shadow background="white">
                  <DropdownMenuButton
                    caption="Delete"
                    cx={css['dropdown-button']}
                    icon={DeleteIcon}
                    onClick={(event: React.MouseEvent<HTMLElement>) => {
                      event.stopPropagation();
                      const target = event.target as HTMLInputElement;

                      onDelete(target.value);
                    }}
                  />
                </Panel>
              )}
              renderTarget={({ ref, onClick: handleMenuItemClick }) => (
                <IconButton
                  ref={ref}
                  icon={navigationMoreIcon}
                  onClick={(event: React.MouseEvent<HTMLElement>) =>
                    openDropdownMenu(event, handleMenuItemClick)
                  }
                />
              )}
            />
          )}
        </FlexRow>
        <FlexRow padding="12" size={null}>
          <Text cx={css.card__description}>
            <div className={css['card__description-text']}>
              {item.description || 'Description'}
            </div>
          </Text>
          <FlexSpacer />
        </FlexRow>
        <FlexRow cx={css.card__details} size={null}>
          <FlexRow cx={css.card__status} size={null}>
            <StatusIndicator color={item.status} size="8" />
            <Text
              cx={`${css['card__status-text']} ${css['card__status-text_disabled']}`}
              font="sans"
              size="24">
              {TASK_STATUS[item.status]}
            </Text>
          </FlexRow>
          <FlexSpacer />
          <Text color="gray60" cx={css.card__date} font="sans" size="24">
            {item.updatedAt
              ? dayjs(item.updatedAt).format('MMM DD, YYYY')
              : dayjs().format('MMM DD, YYYY')}
          </Text>
        </FlexRow>
      </li>
    </div>
  );
};
